module.exports = __webpack_public_path__ + "img/scientist.908e473d.png";